module.exports = __webpack_public_path__ + "static/media/darmody.79972a7f.png";